// extracted by mini-css-extract-plugin
export var editButton = "_o2-0";